// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#unity-container {\n    margin: 0;\n    padding: 0;\n    width: 100%;\n    height: calc(100vh - 200px);\n    overflow: hidden;\n}\n#unity-canvas {\n    /* Make the canvas fill the screen */\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    margin: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
